import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiServiceService} from "../../../Services/api-service.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../Services/auth.service";
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-remita-success-modal',
  templateUrl: './remita-success-modal.component.html',
  styleUrls: ['./remita-success-modal.component.css']
})
export class RemitaSuccessModalComponent implements OnInit{
  @Output() onConfirmClicked = new EventEmitter();
  @Input() details: any;
  isLoading: boolean;

  constructor(
      private apiService: ApiServiceService,
      private router: Router,
      public modalRef: BsModalRef,
      private authenticationService: AuthService,
  ) {
  }

  ngOnInit(): void {
    }

  downloadPaymentReceipt(){
      let url = "/assessments/print/payment/receipt";
      let dto = {
        rrr: this?.details?.rrr
      }
      this.apiService.post(url, dto, { responseType: 'blob' }).subscribe(
          (response: Blob) => {
              this.modalRef.hide();
            const blob = new Blob([response], { type: 'application/pdf' });
            // Create a Blob URL for the PDF content
            const blobUrl = window.URL.createObjectURL(blob);
            // Open PDF in a new tab
            // window.open(blobUrl, '_blank');
            const file = new Blob([response], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            // Optionally, trigger a download by creating an anchor element
            const downloadLink = document.createElement('a');
            downloadLink.href = blobUrl;
            downloadLink.target = '_blank';
            downloadLink.download = 'payment_receipt.pdf'; // File name for download
            // Uncomment this line to trigger the download automatically
            downloadLink.click();
            // alertify.set("notifier", "position", "top-center");
            // alertify.success("Download successful");
              window.location.reload();
          },
          (error) => {
            this.isLoading = false;
            // alertify.set("notifier", "position", "top-center");
            // alertify.error("Error performing this operation");
          }
      );
    }

}
